export enum SortDirEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
